import React, { PureComponent } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { showMsg } from '../../../course/actions/loaderAlert';
import { formatterConvertorForCourse } from './helper/FormatConvertorForCourse';
import { getNewDraggedData } from './helper/getNewDraggedData';
import CoursePlanTree from '../coursePlan/courseListing/CoursePlanTree';
import WarningPopup from './component/WarningPopup';
import { WeekPhase, SubjectPhase, ChapterPhase, ConceptPhase, Phase } from './component';
import { contentManagementAction } from '../../reducers/contentMangementData';
import { DRAG_N_DROP } from '../../Constants/constants';
import { rebuildSubjectsArray } from './helper';
import chapterAddDialog from '../../../goal-management/components/contentDialog/chapterAddDialog';

interface CombinedPhasesProps {
  coursePlan: any;
  data: any;
  setTreeData: Function;
  mockCoursePlan: any;
  setBulkDrag: Function;
  selectedCourseData: any;
  bulkDrag: any;
  subjectTab: string;
  match: any;
  phaseAlignmentResponse: any;
  fromCombo?: boolean;
  showMsg: any;
  isVersion: boolean;
}

interface CombinedPhasesState {
  needConfirmation: boolean;
  isConfirmed: boolean;
  dragEvent: any;
}
class CombinedPhases extends PureComponent<CombinedPhasesProps, CombinedPhasesState> {
  constructor(props: CombinedPhasesProps) {
    super(props);
    this.state = {
      needConfirmation: false,
      isConfirmed: false,
      dragEvent: {},
    };
  }

  componentDidMount = () => {
    setTimeout(() => {
      const { setTreeData, data } = this.props;
      setTreeData({
        treeData: JSON.parse(JSON.stringify(data)),
      });
    }, 1000);
    this.props.showMsg(' Course Plan Details Fetched Successfully ', 'success');
  };


  executeDrop = () => {
    const { source, destination } = this.state.dragEvent;
    const { setTreeData, coursePlan: structure, bulkDrag, setBulkDrag } = this.props;
    const newDraggedData = getNewDraggedData({
      source,
      destination,
      structure,
      bulkDrag,
      setBulkDrag,
    });
    rebuildSubjectsArray(source.droppableId, newDraggedData);
    rebuildSubjectsArray(destination.droppableId, newDraggedData);

    setTreeData({ treeData: { ...newDraggedData } });

    this.setState({ isConfirmed: false, dragEvent: {} });
  };

  getResponse = (response: boolean) => {
    this.setState({ isConfirmed: response, needConfirmation: false }, () => {
      if (this.state.isConfirmed) {
        this.executeDrop();
      }
    });
  };

  isPhaseDeletionRequired = (draggableId: string, source: any, sourcePhase: any) => {
    const indices = source.droppableId.split('-');
    const weekIndex = indices[1] !== 'bulk' ? indices[2] : indices[3];
    const subjectIndex = indices[1] !== 'bulk' ? indices[3] : 0;
    return (
      (draggableId.startsWith('concept') &&
        sourcePhase.weeks.length === 1 &&
        sourcePhase.weeks[weekIndex].subjects.length === 1 &&
        sourcePhase.weeks[weekIndex].subjects[subjectIndex].chapters.length === 1 &&
        sourcePhase.weeks[weekIndex].subjects[subjectIndex].chapters.concepts.length === 1) ||
      (draggableId.startsWith('chapter') &&
        sourcePhase.weeks.length === 1 &&
        sourcePhase.weeks[weekIndex].subjects.length === 1 &&
        sourcePhase.weeks[weekIndex].subjects[subjectIndex].chapters.length === 1)
    );
  };

  onDragEnd = (event: any) => {
    const { draggableId, source, destination } = event;
    const { coursePlan } = this.props;
    const { phases } = coursePlan;
    const destIndices = source.droppableId.split('-');
    const destPhaseIndex = destIndices[1] !== 'bulk' ? destIndices[2] : destIndices[3];
    const isValidDestination = !(
      !destination ||
      destination.droppableId.startsWith('chapter') ||
      destination.droppableId.startsWith('concept') ||
      source.droppableID === destination.droppableId ||
      phases[destPhaseIndex].isRevision
    );
    if (!isValidDestination) {
      return;
    }
    const indices = source.droppableId.split('-');
    let phaseIndex;
    if (indices[1] === 'bulk') {
      phaseIndex = indices[2];
    } else {
      phaseIndex = indices[1];
    }

    const sourcePhase = phases[phaseIndex];

    if (this.isPhaseDeletionRequired(draggableId, source, sourcePhase)) {
      this.setState({ needConfirmation: true, dragEvent: event });
    } else {
      this.setState({ dragEvent: event }, () => {
        this.executeDrop();
      });
    }
    return;
  };
  renderPhases = (
    key: string,
    subjectTab: string,
    handleExpandOnDrag: Function,
    handleExpandNode: Function,
    isExpanded: boolean,
    data?: any,
    childIndex?:number
  ) => {
    switch (key) {
      case 'phase':
        let hasValidSubjects =
          subjectTab === 'All Subjects' ||
          data.subjects.filter(
            (subject: any) =>
              subject.name.toLowerCase() === subjectTab.toLowerCase() && subject.chapterCount > 0
          ).length;
        if (hasValidSubjects) {
          return (
            <Phase
              subjectTab={subjectTab}
              phaseData={data}
              phaseAlignmentResponse={this.props.phaseAlignmentResponse}
              handleExpandOnDrag={handleExpandOnDrag}
              handleExpandNode={handleExpandNode}
              isExpanded={isExpanded}
              isConflict={data.conflict}
              isVersion={this.props.isVersion}
            />
          );
        }

        break;
      case 'week':
        hasValidSubjects =
          subjectTab === 'All Subjects' ||
          data.subjects.filter((subject: any) => subject.name.toLowerCase() === subjectTab.toLowerCase()).length;
        if (hasValidSubjects)
          return (
            <WeekPhase
              weekPhaseData={data}
              phaseAlignmentResponse={this.props.phaseAlignmentResponse}
              handleExpandOnDrag={handleExpandOnDrag}
              handleExpandNode={handleExpandNode}
              isExpanded={isExpanded}
              subjectTab={subjectTab}
            />
          );
        break;
      case 'subject':
        return <SubjectPhase subjectPhaseData={data} />;
      case 'chapter':
        const hasValidChapters =
          subjectTab === 'All Subjects' || data.subjectName.toLowerCase() === subjectTab.toLowerCase();
        if (hasValidChapters) {
          return (
            <ChapterPhase
              chapterPhaseData={data}
              handleExpandNode={handleExpandNode}
              isExpanded={isExpanded}
              subjectTab={subjectTab}
              childIndex={childIndex}
            />
          );
        }
        break;
      case 'concept':
        // const {phases} = this.props.coursePlan;
        // const currentChapter = phases[data.phaseIndex].weeks[data.weekIndex].subjects[data.subjectIndex].chapters[data.chapterIndex]
        // const isLastConcept = data.conceptIndex === currentChapter.concepts.length - 1;
        return (
          <>
            <ConceptPhase 
             conceptPhaseData={data}
             subjectTab={subjectTab}
             childIndex={childIndex}/>
            {/* {isLastConcept && data.chapterContent && data.chapterContent.length && <ChapterLevelContent content={data} />} */}
          </>
        );

      default:
        return <></>;
    }
  };
  render = () => {
    const { coursePlan = {}, phaseAlignmentResponse, fromCombo,setTreeData} = this.props;
    
   return (
      <DragDropContext onDragEnd={(e: any) => this.onDragEnd(e)}>
        <CoursePlanTree
          fromCombo={fromCombo}
          structure={formatterConvertorForCourse(coursePlan,this.props.phaseAlignmentResponse)}
          handleCourseComponent={this.renderPhases}
          match={this.props.match}
        />
        {this.state.needConfirmation && (
          <WarningPopup confirmationFor={DRAG_N_DROP} handleResponse={this.getResponse} />
        )}
      </DragDropContext>
    );
  };
}
const mapStateToProps = (state: any) => {
  return {
    coursePlan: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
    bulkDrag: _.get(state, 'courseMangementData.contentManagementData.bulkDrag', {}),
    selectedCourseData: _.get(state, 'courseMangementData.contentManagementData.selectedCourseData', []),
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setTreeData: contentManagementAction.setTreeData,
      setBulkDrag: contentManagementAction.setBulkDrag,
      showMsg: showMsg,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(CombinedPhases);
